import { render, staticRenderFns } from "./addPosition.vue?vue&type=template&id=0ccc8ae0&scoped=true"
import script from "./addPosition.vue?vue&type=script&lang=js"
export * from "./addPosition.vue?vue&type=script&lang=js"
import style0 from "./addPosition.vue?vue&type=style&index=0&id=0ccc8ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc8ae0",
  null
  
)

export default component.exports